import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { CodeGenerationRequest, DataGenerationRequest, FileData, FileDatabase } from '../../../models/database';

@Injectable({
  providedIn: 'root'
})
export class DataShareService {

  private metadataResponseSubject = new BehaviorSubject<CodeGenerationRequest | null>(null);
  currentCodeGenerationrequest = this. metadataResponseSubject.asObservable();

  private metadataScriptRespose = new BehaviorSubject<DataGenerationRequest | null>(null);
  currentDataGenerationRequest = this.metadataScriptRespose.asObservable();

  private uploadedFileSource = new BehaviorSubject<FileData[]>([]);
  uploadedFiles$ = this.uploadedFileSource.asObservable();

  private selectedDatabaseSource = new BehaviorSubject<string | null>(null);
  selectedDatabase$ = this.selectedDatabaseSource.asObservable();

  private selectedDatabaseSourceType = new BehaviorSubject<string | null>(null);
  selectedDatabaseType$ = this.selectedDatabaseSourceType.asObservable();

  private nodeSelectedSubject = new BehaviorSubject<string>('');
  selectedNode$ = this.nodeSelectedSubject.asObservable()

  private uploadResponseSubject = new BehaviorSubject<any>(null);
  uploadResponse$ = this.uploadResponseSubject.asObservable();

  private userDetailSubject = new BehaviorSubject<any>(null);
  presentUser$ = this.userDetailSubject.asObservable();

  private originalPayload = new BehaviorSubject<CodeGenerationRequest | null>(null);

  constructor() { }

  updateUserDetails(response: any){
    this.userDetailSubject.next(response)
  }

  selectedNodeValue(nodeSel: any){
    this.nodeSelectedSubject.next(nodeSel)
  }

  getCurrentNodeValue(): any {
    return this.nodeSelectedSubject.getValue();
  }

  UpdateCodeGenerationRequest(request: CodeGenerationRequest){
    this.metadataResponseSubject.next(request);
  }

  UpdateDataGeneratedRequest(request: DataGenerationRequest){
    this.metadataScriptRespose.next(request)
  }

  updateUploadedFiles(files: FileData[]){
    this.uploadedFileSource.next(files)
  }

  updateSelectedDatabase(database: string | null){
    this.selectedDatabaseSource.next(database)
  }

  updateSelectedDatabaseType(databaseType: string | null){
    this.selectedDatabaseSourceType.next(databaseType)
  }

  setUploadResponse(response: {database: FileDatabase[]}): void{
    this.uploadResponseSubject.next(response);
  }

  getUploadResponse(): {database: FileDatabase[]} | null {
    return this.uploadResponseSubject.value;
  }

  UpdateOriginalPayload(payload: CodeGenerationRequest) {
    this.originalPayload.next(payload);
  }

  get originalPayload$() {
    return this.originalPayload.asObservable();
  }

  clearData(){
    this.selectedDatabaseSource.next(null);
    this.selectedDatabaseSourceType.next(null);
    this.uploadedFileSource.next([]);
    this.uploadResponseSubject.next(null);
    this.metadataScriptRespose.next(null);
    this.metadataResponseSubject.next(null);
  }
}
